function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
const Listener = require("./listener.js");
var _idCounter = /*#__PURE__*/_classPrivateFieldLooseKey("idCounter");
class EventEmitter {
  constructor() {
    this.listeners = void 0;
    Object.defineProperty(this, _idCounter, {
      writable: true,
      value: void 0
    });
    this.listeners = [];
    _classPrivateFieldLooseBase(this, _idCounter)[_idCounter] = 0;
  }
  removeListener(id) {
    const i = this.listeners.findIndex(listener => listener.id === id);
    if (i !== -1) {
      this.listeners.splice(i, 1);
      return true;
    }
    return false;
  }
  addListener(event, handler) {
    let id = _classPrivateFieldLooseBase(this, _idCounter)[_idCounter]++;
    this.listeners.push(new Listener(id, event, handler));
    return id;
  }
  emit(event, payload) {
    for (const listener of this.listeners) {
      if (listener.event === event) {
        listener.handler(payload);
      }
    }
  }
}
module.exports = EventEmitter;